module.exports = __webpack_public_path__ + "img/image26@3x.3160b405.png";